module.exports = __webpack_public_path__ + "static/img/2.e6a8cad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/2.png
// module id = 69Wt
// module chunks = 0